var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header-container"},[_c('h1',[_vm._v(_vm._s(_vm.$t(_vm.title)))]),_c('button',{staticClass:"close-button-order-list-modal",on:{"click":_vm.close}},[_c('CloseIcon')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }